import React from "react";
import { ForumsTopicPostsContainer } from "../../../containers/forums/ForumsTopicPostsContainer";
import { useForumsNavigation } from "../../../hooks/useForumNavigation";
import { BANNER_FORUM_COHOST_PAGE } from "../../../utilities/assets/assetHelper";
import { EForumTopic } from "../../../utilities/forums";
import { useTranslation } from "react-i18next";

export const ForumsCoHostPage = () => {
    const { t } = useTranslation();
    const { navigateToNewPost, navigateToArticle, navigateToPost } = useForumsNavigation()

    const handleCreateNewPost = () => {
        navigateToNewPost(EForumTopic.COHOST)
    }

    return <ForumsTopicPostsContainer
        topic={EForumTopic.COHOST}
        banner={{
            title: t('forum.cohost.title'),
            backgroundImageSrc: BANNER_FORUM_COHOST_PAGE,
            subTitle: t('forum.cohost.subTitle'),
            primaryButton: { text: t('forum.topic.newPostButton'), onClick: handleCreateNewPost }
        }}
        onCreateNewPostClick={handleCreateNewPost}
        navigateToPost={navigateToPost}
        navigateToArticle={navigateToArticle} />;
}